import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltCommentsSidebarFilterSearchTagsItemName from './VeltCommentsSidebarFilterSearchTagsItemName/VeltCommentsSidebarFilterSearchTagItemName';
import VeltCommentsSidebarFilterSearchTagsItemClose from './VeltCommentsSidebarFilterSearchTagsItemClose/VeltCommentsSidebarFilterSearchTagItemClose';
var VeltCommentsSidebarFilterSearchTagsItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-tags-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterSearchTagsItem.Name = VeltCommentsSidebarFilterSearchTagsItemName;
VeltCommentsSidebarFilterSearchTagsItem.Close = VeltCommentsSidebarFilterSearchTagsItemClose;
export default VeltCommentsSidebarFilterSearchTagsItem;
